import { Text, TextProps } from '@shopify/polaris';
import { memo } from 'react';

interface IProps extends Omit<TextProps, 'as'> {
  children: React.ReactNode;
  className?: string;
}

const BoldRegularText = ({ children, variant, className, ...textProps }: IProps) => {
  return (
    <div className={`d-inline-block ${className || ''}`}>
      <Text as="h5" variant={variant || 'headingSm'} {...textProps}>
        {children}
      </Text>
    </div>
  );
};
export default memo(BoldRegularText);
